export interface UxOption {
    value: string;
    selected?: boolean;
    name: string;
    disabled?: boolean;
}
